import { ComboBoxItemModel } from "@genexus/chameleon-controls-library/dist/types/components/combo-box/types";

export const mapTypesToComboBoxItemModel = (
  synchronizationTypes: any[]
): ComboBoxItemModel[] => {
  const syncTypes: ComboBoxItemModel[] = [];

  synchronizationTypes.forEach(synchronizationType => {
    const newSynchType: ComboBoxItemModel = {
      value: synchronizationType.value,
      caption: synchronizationType.caption
    };
    syncTypes.push(newSynchType);
  });
  return syncTypes;
};
